import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PinholeRoundService {

    constructor(private httpClient: HttpClient) {

    }

    deleteRound(roundToken: string): Observable<any> {
        return this.httpClient.delete(`/rest/admin/delete_round/${roundToken}`);
    }

    undeleteRound(roundToken: string): Observable<any> {
        return this.httpClient.post(`/rest/admin/undelete_round/${roundToken}`, null);
    }
}
